var React = require('react');

function Delete (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"mask0_450_344","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24","key":0},React.createElement("rect",{"width":"24","height":"24","fill":"#D9D9D9"})),React.createElement("g",{"mask":"url(#mask0_450_344)","key":1},React.createElement("path",{"d":"M5 21V6H4V4H9V3H15V4H20V6H19V21H5ZM7 19H17V6H7V19ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z","fill":"black"}))]);
}

Delete.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Delete;

Delete.default = Delete;
